export default {
    INFO: 1,
    WARN: 2,
    ERROR: 3,
    OFF: 4
};
//# sourceMappingURL=levels.js.map